import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import * as actions_stock from "redux/actions/stockOrderActions";
import * as actions_dashboard from "redux/actions/dashboardActions";
import { Translate, I18n } from "react-redux-i18n";
import InputDate from 'components/InputDate';

const FormDialog = (props) => {

    const { item, ...rest } = props;

    const handleClose = () => {
        if (typeof props.close === 'function') {
            props.close();
        }
    };

    const resolveSymbol = () => values.symbol || item.symbol || props.symbol;
    const resolveStockId = () => values.stock_id || item.id;

    const buildPayload = (extra = {}) => ({
        ...values,
        stock_id: resolveStockId(),
        symbol: resolveSymbol(),
        open_price: Number(values.open_price ?? item.open_price),
        quantity: Number(values.quantity),
        close_price: Number(values.close_price),
        ...extra,
    });

    const shouldCloseSymbol = () => {
        if (props.isSubOrder) return false;
        const counter = Number(item.counter ?? props.parentCounter);
        if (counter > 1) return true;
        return Array.isArray(item.sub_order) && item.sub_order.length > 1;
    };

    const handleSave = () => {
        const payload = buildPayload();
        if (shouldCloseSymbol())
            props.updateSymbol(payload, props.token);
        else
            props.updateItem(payload, props.token);

        props.loadListIndicator(props.user_id, props.token);
        handleClose();
    };

    const handleSaveShare = () => {
        const payload = buildPayload({ share: true });
        if (shouldCloseSymbol())
            props.updateSymbol(payload, props.token);
        else
            props.updateItem(payload, props.token);
        handleClose();
    };

    const [values, setValues] = useState({
        stock_id: item.id || undefined,
        open_price: item.open_price || 0.01,
        symbol: item.symbol,
        quantity: item.quantity,
        close_price: props.price || Math.abs(item.open_price) || 0,//
        close_at: new Date().toISOString().split('T')[0],//props.item.open_at || 
        market: item.market === 'BUY' ? 'SELL' : 'BUY',
        id: props.user_id,
        quantity_tmp: item.quantity,
        counter: item.counter,
        isValid: true
    });

    const getSignedOpenPrice = (openPrice, positionMarket) => {
        const absOpen = Math.abs(Number(openPrice) || 0);
        return positionMarket === 'BUY' ? -absOpen : absOpen;
    };

    const calcClosePl = (quantity, openPrice, closePrice, positionMarket, closeMarket) => {
        const qty = Number(quantity) || 0;
        const signedOpen = getSignedOpenPrice(openPrice, positionMarket);
        const signedClose = closeMarket === 'BUY'
            ? -Number(closePrice)
            : Number(closePrice);
        return qty * (signedClose + signedOpen);
    };

    const validateForm = (formValues) => {
        const qty = Number(formValues.quantity);
        const maxQty = Number(formValues.quantity_tmp);
        if (!qty || qty > maxQty)
            return { quantity: "Quantity is wrong" };
        return null;
    }

    useEffect(() => {
        setValues({
            stock_id: item.id,
            open_price: item.open_price || 0.01,
            symbol: item.symbol || props.symbol,
            quantity: item.quantity,
            close_price: props.price || Math.abs(item.open_price) || 0,
            close_at: new Date().toISOString().split('T')[0],
            market: item.market === 'BUY' ? 'SELL' : 'BUY',
            id: props.user_id,
            quantity_tmp: item.quantity,
            counter: item.counter ?? props.parentCounter,
            isValid: true
        });
    // Only re-seed when opening a different lot — not when list refresh swaps props under an open modal.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item.id]);

    useEffect(() => {
        const errors = validateForm(values);
        setValues(values => ({
            ...values,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [values.quantity]);


    const handleChange = (event) => {
        event.persist();
        setValues(values => ({
            ...values,
            [event.target.name]: event.target.value,

        }));
    };

    return (
        // <div key={props.key} style={{ "display": "inline" }}>
        //     <button className='btn btn-primary btn-sm'
        //         // color="primary"
        //         // variant="contained"
        //         // size="small"
        //         onClick={handleClickOpen}>
        //         <Translate value="close" />
        //     </button>
        //     {open && (
            <div className='dialog'  onClose={handleClose} >
                
                <div className='dialog-content' style={{ "maxWidth": "500px" }}>
                    <div className='dialog-title'> Stock Close {item.symbol}</div>
                    <div className='dialog-content-text'>
                        Enter Data Stock
                    </div>
                    <div className="entry-form-grid entry-form-grid--3">
                        <div className="entry-field">
                            <label htmlFor="quantity">Quantity</label>
                            <input
                                autoFocus
                                id="quantity"
                                name="quantity"
                                type="number"
                                min="1"
                                onChange={handleChange}
                                value={values.quantity}
                            />
                        </div>
                        <div className="entry-field">
                            <label htmlFor="close_price">Close price</label>
                            <input
                                id="close_price"
                                name="close_price"
                                type="number"
                                min="0.01"
                                step="0.01"
                                inputProps={{
                                    step: 0.01,
                                }}
                                onChange={handleChange}
                                value={values.close_price}
                            />
                        </div>
                        <div className="entry-field" >
                            <label htmlFor="close_at">Close date</label>
                            <InputDate
                                id="close_at"
                                name="close_at"
                                required="true"
                                label=""
                                value={values.close_at}
                                onChange={handleChange}
                                min="1900-01-01"
                                max={new Date().toISOString().split('T')[0]}
                                disabled={false}
                            />
                        </div>
                    </div>
                    {
                        values.counter === 1 && (
                            <span style={{
                                "paddingTop": "10px",
                            }}>
                                {(values.quantity * parseFloat(values.close_price)).toFixed(2)} {"USD. P/L = " + calcClosePl(values.quantity, values.open_price, values.close_price, item.market, values.market).toFixed(2)}
                            </span>
                        )
                    }

              
                <div className='dialog-actions'>
                    <button 
                        className='btn btn-secondary'
                        onClick={props.close}
                        >
                            <Translate value="cancel" />
                        </button>
                    <button 
                        className='btn btn-primary'
                        onClick={handleSaveShare}
                        disabled={!values.isValid}
                    > 
                        <Translate value="save_share" />
                    </button>
                    <button 
                        className='btn btn-primary'
                        onClick={handleSave}
                        disabled={!values.isValid}
                    > 
                        <Translate value="save" />
                    </button>
                </div>
                  </div>
            </div>
        //     )}
        // </div>
    );
}

function mapStateToProps(reducer) {
    // console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token
    };
}
const mapDispatchToProps = dispatch => ({
    updateItem: (params, token) =>
        dispatch(actions_stock.updateItem({ params, token })),
    updateSymbol: (params, token) =>
        dispatch(actions_stock.updateSymbol({ params, token })),
    ////////////////////////////////
    loadListIndicator: (user_id, token) =>
        dispatch(actions_dashboard.loadListIndicator({ user_id, token })),

});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);